import { ClassList } from 'lib/utils/react/classlist';
import React from 'react';
import { LuBadgeAlert, LuBadgeCheck, LuBadgeInfo, LuBadgeX, LuX } from 'react-icons/lu';
import { ToastItemOpts } from './toast-properties';

export const ToastRenderer: React.FC<{ items: ToastItemOpts[] }> = ({ items }) => {
  return (
    <div className="toast-provider">
      {items.map((item, index) => (
        <Toast key={item.id ?? 'toast-index-' + index} {...item} />
      ))}
    </div>
  );
};

export const Toast: React.FC<ToastItemOpts> = ({
  id,
  type,
  message,
  duration,
  isClosable
}) => {
  const [isClosed, setClosed] = React.useState(false);

  const classes = ClassList.of('toast')
    .add(`toast-${type}`)
    .add('toast-closing', (duration ?? 0) <= 0)
    .add('toast-closed', (duration ?? 0) <= -2450 || isClosed);

  const messageClasses = ClassList.of('toast-message').add(
    'toast-message-closable',
    isClosable
  );

  return (
    <div className={classes.names}>
      {type === 'success' && <LuBadgeCheck className="toast-icon" />}
      {type === 'error' && <LuBadgeX className="toast-icon" />}
      {type === 'warning' && <LuBadgeAlert className="toast-icon" />}
      {type === 'info' && <LuBadgeInfo className="toast-icon" />}
      <div className={messageClasses.names}>{message}</div>
      {isClosable && (
        <LuX className="toast-close-button" onClick={() => setClosed(true)} />
      )}
    </div>
  );
};
